import { gql } from '@apollo/client'

export const CREATE_DASHBOARD_MUTATION = gql`
  mutation createDashboard($workspaceJobInput: CreateWorkspaceJobInput!) {
    createWorkspaceJob(workspaceJob: $workspaceJobInput) {
      id
      workspaceId
      name
      type
      description
      ownerName
      isPublic
      isOwner
      createdAt
      updatedAt
      report {
        id
      }
      details {
        brand
        territory
        startDate
        endDate
        gender
        age
        country
      }
    }
  }
`
